import {
    apiCguCreateCambiarPassword,
    apiCguGetUsuariosPermisos,
    apiCguRecuperarPassword,
    apiCguUserLogin,
    apiConfirmaCorreo,
} from "../settings/apiConfig";
import { createContext, useContext, useEffect, useState } from "react";
import { fnPrevent, fnPreventBlur } from "../settings/preventConfig";
import { getFormCambiarPass, getFormLogin, getFormRecuperar } from "../models/LoginModel";
import { getKey, getToken } from "../models/TokenModel";
import { urlDefault, urlSystem } from "../settings/urlConfig";

import { EnumPerfilesPrincipales } from "../settings/enumConfig";
import { createMemoryHistory } from "history";
import { fnHandleChangeText } from "../settings/handleConfig";
import { rxCorreo } from "../settings/regexConfig";
import { useCatalogo } from "./CatalogoContext";
import { useHistory } from "react-router-dom";
import { useLayout } from "./LayoutContext";
import { useRequest } from "./RequestContext";
import { useToken } from "./TokenContext";

export const LoginContext = createContext();

export function LoginProvider(props) {
    const tokenName = "MeditocTkn";
    const keyName = "MeditocKey";

    const history = createMemoryHistory();
    const navigate = useHistory();
    const { Get, Post } = useRequest();
    const { handleClickObtenerCatalogos } = useCatalogo();
    const { handleChangeKey, handleChangeToken } = useToken();
    const { rutaActual, handleOpenAlert, handleChangeRuta, handleOpenMenu, handleCloseUserMenu } = useLayout();

    const [usuarioSesion, setUsuarioSesion] = useState(null);
    const [usuarioActivo, setUsuarioActivo] = useState(true);
    const [usuarioPermisos, setUsuarioPermisos] = useState(null);
    const [formLogin, setFormLogin] = useState(getFormLogin());
    const [formRecuperar, setFormRecuperar] = useState(getFormRecuperar());
    const [formCambiarPass, setFormCambiarPass] = useState(getFormCambiarPass());
    const [openFormRecuperar, setopenFormRecuperar] = useState(false);
    const [openFormEnvioCorreo, setopenFormEnvioCorreo] = useState(false);
    const [ConfirmacionExitosa, setConfirmacionExitosa] = useState(null);
    const [openPortadaLogin, setopenPortadaLogin] = useState(false);
    const [openFormCambiarPass, setopenFormCambiarPass] = useState(false);
    const [mostrarPassword, setMostrarPassword] = useState(false);
    const [functionCloseAll, setFunctionCloseAll] = useState(null);

    const [lngConfirmCorreo, setlngConfirmCorreo] = useState("es");

    const handleToggleFormRecuperar = (value) => {
        setopenFormRecuperar(value);
    };
    const handleTogglePortadaLogin = (value) => {
        setopenPortadaLogin(value);
    };
    const handleToggleFormCambiarPass = (value) => {
        setopenFormCambiarPass(value);
    };

    const handleChangeMostrarPassword = (value) => {
        setMostrarPassword(value);
    };

    const handleChangeFunctionCloseAll = (value) => {
        setFunctionCloseAll(value);
    };

    const handleChangeUsuarioPermisos = (value) => {
        setUsuarioPermisos(value);
    };

    const handleChangeFormLogin = fnHandleChangeText(formLogin, setFormLogin);
    const handleChangeFormRecuperar = fnHandleChangeText(formRecuperar, setFormRecuperar);
    const handleChangeFormCambiarPass = fnHandleChangeText(formCambiarPass, setFormCambiarPass);

    const handleSubmitLogin = (e) => {
        fnPrevent(e);

        const { txtUsuarioMeditoc, txtPasswordMeditoc } = formLogin;
        if (txtUsuarioMeditoc.value === "" || txtPasswordMeditoc.value === "") {
            handleOpenAlert("Por favor, ingrese todos los datos", "warning");
            return;
        }

        const entLogin = {
            sUsuario: txtUsuarioMeditoc.value,
            sPassword: txtPasswordMeditoc.value,
        };

        fnLogin(entLogin);
    };

    const handleSubmitRecuperar = (e) => {
        fnPrevent(e);

        const { txtRecuperarMeditoc } = formRecuperar;
        if (txtRecuperarMeditoc.value === "") {
            handleOpenAlert("Por favor, ingrese su correo de recuperación", "warning");
            return;
        }

        if (!rxCorreo.test(txtRecuperarMeditoc.value)) {
            handleOpenAlert("Por favor, ingrese un correo válido", "warning");
            return;
        }

        const entRecuperar = {
            sCorreo: txtRecuperarMeditoc.value,
        };

        fnRecuperar(entRecuperar);
    };

    const handleSubmitCambiarPass = (e) => {
        fnPrevent(e);
        const { txtNuevoPasswordMeditoc, txtConfirmarPasswordMeditoc } = formCambiarPass;

        const form = {
            ...formCambiarPass,
            txtNuevoPasswordMeditoc: {
                ...txtNuevoPasswordMeditoc,
                error: txtNuevoPasswordMeditoc.value === "",
            },
            txtConfirmarPasswordMeditoc: {
                ...txtConfirmarPasswordMeditoc,
                error: txtConfirmarPasswordMeditoc.value === "",
            },
        };
        setFormCambiarPass(form);

        if (
            Object.values(form)
                .map((x) => x.error)
                .includes(true)
        ) {
            return;
        }

        if (txtNuevoPasswordMeditoc.value !== txtConfirmarPasswordMeditoc.value) {
            handleOpenAlert("Las contraseñas no coinciden", "warning");
            return;
        }

        fnCambiarPass(usuarioSesion.iIdUsuario, txtConfirmarPasswordMeditoc.value, usuarioSesion.iIdUsuario);
    };

    const handleClickCambiarPassword = () => {
        handleCloseUserMenu();
        setopenFormCambiarPass(true);
    };

    const handleClickSignOff = async () => {
        handleCloseUserMenu();
        if (rutaActual === urlSystem.callcenter.consultas) {
            if (typeof functionCloseAll === "function") {
                await functionCloseAll();
            }
            //Esperar para reiniciar el chat
            setTimeout(() => {
                fnBorrarDatos();
            }, 1000);
        } else {
            fnBorrarDatos();
        }
    };

    const handleClickRuta = async (e, ruta) => {
        const funcCloseDrawer = handleOpenMenu(false);
        funcCloseDrawer(e);

        if (rutaActual === urlSystem.callcenter.consultas) {
            if (typeof functionCloseAll === "function") {
                await functionCloseAll();
            }

            //Esperar para reiniciar el chat
            setTimeout(() => {
                handleChangeRuta(ruta);
                navigate.push(ruta);
            }, 1000);
        } else {
            handleChangeRuta(ruta);
            navigate.push(ruta);
        }
    };

    const fnLogin = async (entLogin) => {
        const payload = {
            loader: "Validando datos de sesión...",
            url: apiCguUserLogin,
            body: entLogin,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            sessionStorage.setItem(tokenName, entLogin.sUsuario);
            sessionStorage.setItem(keyName, entLogin.sPassword);
            handleChangeKey(getKey());
            handleChangeToken(getToken());
            setUsuarioActivo(true);
            setUsuarioSesion(response.Result);
        } else {
            sessionStorage.removeItem(tokenName);
            sessionStorage.removeItem(keyName);
        }
    };

    const fnConfirmacionCorreo = async (token) => {
        var stoken = token.substr(token.indexOf("sIdToken=") + 9);
        var lng = token.substr(token.indexOf("lng=") + 4, 2);
        setlngConfirmCorreo(lng);
        const entToken = {
            sIdToken: stoken,
        };
        const payload = {
            loader: lng === "es" ? "Validando Correo..." : "Validating Mail ...",
            url: apiConfirmaCorreo,
            body: entToken,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setConfirmacionExitosa(true);
        } else {
            setConfirmacionExitosa(false);
        }
    };

    const fnObtenerPermisosPerfiles = async (iIdPerfil) => {
        await fnGetPermisos(iIdPerfil);
        await handleClickObtenerCatalogos();
    };

    const fnGetPermisos = async (iIdPerfil) => {
        const payload = {
            loader: "Obteniendo permisos...",
            url: apiCguGetUsuariosPermisos + "?piIdPerfil=" + iIdPerfil,
            alert: false,
        };

        const response = await Get(payload);
        if (response.Code === 0) {
            setUsuarioPermisos(response.Result);
            fnRutaSesion(iIdPerfil);
        }
    };

    const fnRutaSesion = (iIdPerfil) => {
        let ruta = urlDefault;
        switch (iIdPerfil) {
            case EnumPerfilesPrincipales.DoctorCallCenter:
                ruta = urlSystem.callcenter.consultas;
                break;
            case EnumPerfilesPrincipales.DoctorEspecialista:
                ruta = urlSystem.callcenter.consultas;
                break;
            case EnumPerfilesPrincipales.AdministradorEspecialiesta:
                ruta = urlSystem.callcenter.administrarConsultas;
                break;
            default:
                ruta = urlDefault;
                break;
        }
        handleChangeRuta(ruta);
        navigate.push(ruta);
    };

    const fnValidarSesionGuardada = () => {
        const sUsuario = sessionStorage.getItem(tokenName);
        const sPassword = sessionStorage.getItem(keyName);

        if (sUsuario && sPassword) {
            fnLogin({ sUsuario, sPassword });
        }
    };

    const fnRecuperar = async (entRecuperar) => {
        const payload = {
            loader: "Recuperando y enviando correo...",
            url: apiCguRecuperarPassword,
            body: entRecuperar,
            alert: true,
        };

        const response = await Post(payload);
        if (response.Code === 0) {
            setopenFormRecuperar(false);
            setFormLogin(getFormLogin());
            setFormRecuperar(getFormRecuperar());
        }
    };

    const fnBorrarDatos = () => {
        sessionStorage.removeItem(tokenName);
        sessionStorage.removeItem(keyName);

        setUsuarioSesion(null);
        setUsuarioActivo(false);
        setUsuarioPermisos(null);

        handleChangeKey("");
        handleChangeToken("");

        handleChangeRuta(urlDefault);
        navigate.push(urlDefault);
    };

    const fnCambiarPass = async (iIdUsuario = 0, sPassword = "", iIdUsuarioUltMod = 0) => {
        const payload = {
            loader: "Actualizando credenciales...",
            url:
                apiCguCreateCambiarPassword +
                "?iIdUsuario=" +
                iIdUsuario +
                "&sPassword=" +
                sPassword +
                "&iIdUsuarioUltMod=" +
                iIdUsuarioUltMod,
            body: {},
            alert: true,
        };
        const response = await Post(payload);
        if (response.Code === 0) {
            sessionStorage.setItem(keyName, sPassword);
            setopenFormCambiarPass(false);
        }
        fnPreventBlur();
    };

    useEffect(() => {
        if (navigate.location.pathname == "/ConfirmaCorreo") {
            setopenPortadaLogin(true);
            setopenFormEnvioCorreo(true);
            fnConfirmacionCorreo(navigate.location.search);
        } else {
            setopenPortadaLogin(true);
            fnValidarSesionGuardada();
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (usuarioSesion) {
            if (usuarioSesion.iIdPerfil) {
                fnObtenerPermisosPerfiles(usuarioSesion.iIdPerfil);
            }
        }
        // eslint-disable-next-line
    }, [usuarioSesion]);

    useEffect(() => {
        if (openFormCambiarPass) {
            setFormCambiarPass(getFormCambiarPass());
        }
        // eslint-disable-next-line
    }, [openFormCambiarPass]);

    return (
        <LoginContext.Provider
            value={{
                usuarioSesion,
                usuarioActivo,
                usuarioPermisos,
                formLogin,
                formRecuperar,
                formCambiarPass,
                openFormRecuperar,
                openFormEnvioCorreo,
                ConfirmacionExitosa,
                openPortadaLogin,
                openFormCambiarPass,
                mostrarPassword,
                functionCloseAll,
                lngConfirmCorreo,
                handleToggleFormRecuperar,
                handleTogglePortadaLogin,
                handleToggleFormCambiarPass,
                handleChangeMostrarPassword,
                handleChangeFunctionCloseAll,
                handleChangeUsuarioPermisos,
                handleChangeFormLogin,
                handleChangeFormRecuperar,
                handleChangeFormCambiarPass,
                handleSubmitLogin,
                handleSubmitRecuperar,
                handleSubmitCambiarPass,
                handleClickCambiarPassword,
                handleClickSignOff,
                handleClickRuta,
            }}
        >
            {props.children}
        </LoginContext.Provider>
    );
}

export function useLogin() {
    return useContext(LoginContext);
}
